/**
 * Procedure Categories and Procedures for DM in Endocrinology students
 * Extracted with strict evidence from official NMC PDF (Page 4, 5, 12: "Psychomotor domain - perform independently")
 */
export const ENDOCRINOLOGY_PROCEDURES = {
  "Dynamic Endocrine Testing & Metabolic Procedures": [
    "ACTH & LHRH Endocrine Stimulation Tests",
    "Water Deprivation Test for Diabetes Insipidus",
    "Prolonged 72-Hour Fasting Test for Hypoglycemia / Insulinoma",
    "Autonomic Function Testing (AFT) in Diabetes & Endocrine Disorders",
    "Dynamic Endocrine Hormonal & Metabolic Assays (ELISA / RIA / CLIA)",
    "Formulation of Integrated Diabetes & Metabolic Nutrition Plans",
  ],
  "Endocrine Interventional, Ultrasound & Laboratory Procedures": [
    "Thyroid & Neck Ultrasonography",
    "Fine Needle Aspiration Cytology (FNAC) of Thyroid Nodules & Glands",
    "Inferior Petrosal Sinus Sampling (IPSS) & Adrenal Venous Sampling (AVS)",
    "Radioactive Iodine (RAI) & Technetium Uptake / Thyroid Isotope Scans",
    "Diabetic Foot Offloading Techniques & Basic Orthotic Fitting",
    "Endocrine Molecular Genetics (DNA Extraction & PCR Assays)",
  ],
};

export const ENDOCRINOLOGY_CATEGORIES = Object.keys(ENDOCRINOLOGY_PROCEDURES);

export const isDMInEndocrinologyDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (d.includes("endocrinology") || d.includes("endocrine")) && !d.includes("surgery");
};
